import React, { useState, useEffect } from 'react';
import LoadCastFile from '../UploadCast';
import PerformerUpsert from './PerformerUpsert';
import PerformerDetail from './PerformerDetail';

export default function PerformerLanding(subEntity: any) {

    let [PerformerCount, SetPerformerCount] = useState(0);
    let [loadCast, SetloadCast] = useState(false);
    let [PerformersUpsert, SetPerformersUpsert] = useState(false);

    const PerformersUpsertChange = (e: any) => {
        PerformersUpsert = false
        SetPerformersUpsert(PerformersUpsert)
    }
    const LoadCastFileChange = (e: any) => {
        loadCast = false
        SetloadCast(loadCast)
    }


    const performers = [
        {
            memberID: "PFM-33449",
            displayName: "Adam Brown",
            firstName: "Adam",
            lastName: "Brown",
            alias: "Adam Brown (name)",
            Status: "member",
            castAppearances: 12,
            productions: 3,
            lastActivity: "2026-05-02",
        },
        {
            memberID: "PFM-25877",
            displayName: "Ben Smith",
            firstName: "Ben",
            lastName: "Smith",
            alias: "Ben Smith (NomemberID)",
            Status: "member",
            castAppearances: 12,
            productions: 3,
            lastActivity: "2026-04-23",
        },
        {
            memberID: "PFM-27895",
            displayName: "Chloe White",
            firstName: "Chloe",
            lastName: "White",
            alias: "Emma Jound (Hongaw)",
            Status: "unverified",
            castAppearances: 18,
            productions: 5,
            lastActivity: "2026-01-23",
        },
        {
            memberID: null,
            displayName: "Samantha Clark",
            firstName: "Samantha",
            lastName: "Clark",
            alias: "Remee Ann",
            Status: "unverified",
            castAppearances: 8,
            productions: 2,
            lastActivity: "2025-04-20",
        },
        {
            memberID: "PFM-21134",
            displayName: "Freddie Maclean",
            firstName: "Freddie",
            lastName: "Maclean",
            alias: null,
            Status: "non-member",
            castAppearances: 45,
            productions: 5,
            lastActivity: "2026-03-28",
        },
        {
            memberID: null,
            displayName: "Jack Dawson",
            firstName: "Jack",
            lastName: "Dawson",
            alias: null,
            Status: "non-member",
            castAppearances: 0,
            productions: 0,
            lastActivity: "2026-02-20",
        },
        {
            memberID: null,
            displayName: "Megan Patel",
            firstName: "Megan",
            lastName: "Patel",
            alias: null,
            Status: "non-member",
            castAppearances: 0,
            productions: 1,
            lastActivity: "2024-02-22",
        },
        {
            memberID: null,
            displayName: "Noelle Brooks",
            firstName: "Noelle",
            lastName: "Brooks",
            alias: null,
            Status: "non-member",
            castAppearances: 0,
            productions: 0,
            lastActivity: "2024-12-27",
        },
        {
            memberID: null,
            displayName: "Thomas Evans",
            firstName: "Thomas",
            lastName: "Evans",
            alias: null,
            Status: "non-member",
            castAppearances: 0,
            productions: 0,
            lastActivity: "2024-12-07",
        },
    ];

    const memberstatus = (e: any) => {


        var html = " <div> hello </div>"

        return html
    }


    let [yearOption, SetYearOption] = useState<any>([]);
    useEffect(() => {
        const startYear = 1990;
        const currentYear = new Date().getFullYear();

        const years = Array.from(
            { length: currentYear - startYear + 1 },
            (_, i) => currentYear - i
        );

        console.log(years)

        yearOption = years;
        SetYearOption(yearOption)
        console.log(yearOption)
    }, [])

    let [PerformerSelection, SetPerformerSelection] = useState<any>([]);
    let [PerformerDetailOpen, SetPerformerDetailOpen] = useState(false);

    const PerformerDetail_open = (e: any) => {
        PerformerSelection = e;
        SetPerformerSelection(PerformerSelection)
        PerformerDetailOpen = true
        SetPerformerDetailOpen(PerformerDetailOpen)

    }
    const PerformerDetailChange = (e: any) => {
        PerformerDetailOpen = false
        SetPerformerDetailOpen(PerformerDetailOpen)
    }

    let [searchFor, SetSearch] = useState("");
    let [activitySelection, SetactivitySelection] = useState("");
    let [statusSelection, SetStatusSelection] = useState("");
    let [updatedSelection, SetupdatedSelection] = useState("");
    let [PerformerSelected, SetPerformerSelected] = useState<any>([]);

    const clearFilter = () => {
        searchFor = '';
        SetSearch(searchFor)

        activitySelection = '';
        SetactivitySelection(activitySelection)

        statusSelection = '';
        SetStatusSelection(statusSelection)

        updatedSelection = '';
        SetupdatedSelection(updatedSelection)
    }

    return (<>

        <div className="ws-12 prl">

            <div className='ws-12 box mbl'>
                <div className='ws-12 pm'>

                    <div className='w-75'>
                        <div className='ws-6 box ps height40'>
                            <input type="text" className="ws-12 pull-right height30" value={searchFor} onChange={(e) => SetSearch(e.target.value)}
                                placeholder='Search by performer name, BECS ID, alternate name' style={{ border: 'none', outline: 'none' }} />
                        </div>

                        <select className='pm pbl height40 grey text-bold icon-btn info' value={statusSelection} onChange={(e: any) => SetStatusSelection(e.target.value)}>
                            <option value={'All'}> All</option>
                            <option value={'BECS Member'}> BECS Member</option>
                            <option value={'Non-member'}> Non-member </option>
                            <option value={'Unverified'}> Unverified  </option>
                        </select>

                        <select className='pm pbl height40 width110 grey text-bold center icon-btn info' value={activitySelection} onChange={(e: any) => SetactivitySelection(e.target.value)}>
                            <option> All</option>
                            <option value={'Used in casts'}>Used in casts</option>
                            <option value={'Not yet used'}> Not yet used </option>
                        </select>

                        <select className='pm pbl height40 width85 grey text-bold icon-btn info' title='Broadcaster/Producer' value={updatedSelection} onChange={(e: any) => SetupdatedSelection(e.target.value)}>
                            <option> All time </option>
                            <option value={'Last 30 days'}>Last 30 days</option>
                            <option value={'Last year'}>Last year</option>
                        </select>

                        <select className='pm pbl height40 width90 white text-bold icon-btn info hide'  >
                            <option> Filter </option>
                        </select>
                    </div>
                    {(searchFor.length > 0 || statusSelection.length > 0 || activitySelection.length > 0 || updatedSelection.length > 0) &&
                        <button type="button" className="text-bold icon-btn delete height40 mr pull-left width70" onClick={clearFilter}>Clear</button>}
                    <button type="button" className="text-bold icon-btn edit pull-right height40" onClick={() => SetPerformersUpsert(true)}>New Performer</button>
                    <button type="button" className="text-bold icon-btn info pull-right height40" >Export</button>
                </div>
            </div>


            {(searchFor.length > 0 || statusSelection.length > 0 || activitySelection.length > 0 || updatedSelection.length > 0) && <div className='ws-12 pm'>

                <div className='ws-12 box landing pm text-center'>
                    {searchFor.length > 0 && <>
                        <span className='text-bold mr'>Search : </span>
                        <span className='mr'>{searchFor} </span>
                    </>}

                    {statusSelection.length > 0 && <>
                        <span className='text-bold mr'>Status :</span>
                        <span className='mr'>{statusSelection}</span>
                    </>}

                    {activitySelection.length > 0 && <>
                        <span className='text-bold mr'>Activity :</span>
                        <span className='mr'>{activitySelection}</span>
                    </>}
                    {updatedSelection.length > 0 && <>
                        <span className='text-bold mr'>Updated :</span>
                        <span className='mr'>{updatedSelection}</span>
                    </>}
                </div>

            </div>}
            
            <div className='ws-12'>

                <table className="newTable box">
                    <thead>
                        <tr>
                            <th >Performer Name</th>
                            <th >Status</th>
                            <th >Member ID</th>
                            <th >Cast Appearances</th>
                            <th >Productions</th>
                            <th >Last Activity</th>
                            <th >Operations</th>
                        </tr>
                    </thead>
                    <tbody>
                        {performers.map((row: any) => (
                            <tr>
                                <td>
                                    <div className='ws-12' onClick={() => PerformerDetail_open(row)}>
                                        <h2 className='ws-12 primary'>{row.displayName}</h2>
                                        <h3 className='ws-12'>{row.firstName} ({row.lastName} )</h3>
                                    </div>

                                </td>
                                <td>
                                    {(row.Status == 'BECS Member') && <div className='width120 height30'>
                                        <div className='bg-level7 height30'>
                                            <span className='white'>✅ {row.Status}</span>
                                        </div>
                                    </div>}

                                    {(row.Status == 'member') && <div className='width120 height30'>
                                        <div className='bg-level7 ps text-center borderRadius-s height30'>
                                            <span className='white '>✅ {row.Status}</span>
                                        </div>
                                    </div>}

                                    {(row.Status == 'unverified') && <div className='width120 height30'>
                                        <div className='bg-level9 ps text-center borderRadius-s height30'>
                                            <span className='white '>⚠️ {row.Status}</span>
                                        </div>
                                    </div>}

                                    {(row.Status == 'non-member' && row.memberID != null) && <div className='width120 height30'>
                                        <div className='bg-level11 ps text-center borderRadius-s height30'>
                                            <span className='white '>⛔ {row.Status}</span>
                                        </div>
                                    </div>}

                                    {(row.Status == 'non-member' && row.memberID == null) && <div className='width120 height30'>
                                        <div className='bg-level17 ps text-center borderRadius-s height30'>
                                            <span className='white '>⛔ {row.Status}</span>
                                        </div>
                                    </div>}
                                </td>
                                <td>
                                    {row.memberID && <>{row.memberID}</>}
                                    {!row.memberID && <div className='text-bold text-center'> - </div>}
                                
                                </td>
                                <td>{row.castAppearances}</td>
                                <td>{row.productions}</td>
                                <td>{row.lastActivity}</td>
                                <td>

                                    <div className=" hover-box text-center ">
                                        <div className="hover-box   text-l text-bold"> ... </div>

                                        <ul className="box hover-block rightReset ws-2 pull-left landing">
                                            <div className='pt ws-12 '> <button className="pull-left icon-btn info width190 ">View</button> </div>
                                            <div className='pt ws-12 '><button className="pull-left icon-btn edit width190" onClick={() => {SetPerformersUpsert(true);SetPerformerSelected(row)}}>Edit</button></div>
                                            <div className='pt ws-12 '><button className="pull-left icon-btn info width190">Link to BECS Member</button></div>
                                            <div className='pt ws-12 '> <button className="pull-left icon-btn info width190">Merge performer</button></div>
                                            <div className='pt ws-12 '> <button className="pull-left icon-btn info width190">Archive</button> </div>
                                        </ul>

                                    </div>

                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>

                {(PerformerCount == 0 && (performers.length == 0)) && <div className='ws-12 box text-center'>

                    <div style={{ paddingTop: "100px", paddingBottom: "100px" }}>

                        <img
                            src="https://cdn-icons-png.flaticon.com/512/1179/1179120.png"
                            alt="No data"
                            className="empty-icon"
                        />

                        <h1 className='text-bold'>No Performers yet</h1>
                        <h3 className='text-bold grey'>Create your first Performer to begin recording casts and cues.</h3>

                        <div className=' ptxl paddingCenterBox'>
                            <button type="button" className=" icon-btn primary white text-bold bg-level5 paddingCenterBox height40 mr" onClick={() => SetPerformersUpsert(true)}>New Performer</button>
                        </div>
                    </div>


                </div>}

            </div>

            {
                (() => {
                    if (PerformersUpsert) {
                        return <PerformerUpsert PerformersUpsertChange={PerformersUpsertChange} PerformerUpsertOpen={PerformersUpsert} PerformerSelected={PerformerSelected}/>
                    }

                    if (loadCast) {
                        return <LoadCastFile LoadCastFileChange={LoadCastFileChange} loadCast={loadCast} />
                    }

                    if (PerformerDetailOpen) {
                        return <PerformerDetail PerformerDetailChange={PerformerDetailChange} PerformerSelection={PerformerSelection} PerformerDetailOpen={PerformerDetailOpen} />
                    }
                })()
            }
        </div>
    </>)
}